import React, { useEffect, useRef, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import "../scss/card.css"
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../hooks/useAuthorizedReuestCommon';
import { generateAxiosInstanceCommonFileUpload } from '../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { CModal } from '@coreui/react';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import ViewImageAndText from '../components/ViewImageAndText';
import { getLink, handleQuestionUpdate, handleSelectAll, ImageModal, isErrorQuestion, Loader, SolutionModal, validateQuestionData } from '../components/ModalsCommonFunctions';

const UploadContentTextBook = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()

    const initialFormState = {
        syllabusStructureMasterId: '',
        lessonMasterId: '',
        topicMasterId: '',
        subTopicMasterId: '',
        subjectMasterId: '',
        importFile: "",
        questionData: []
    }
    const [showPdfLink, setShowPdfLink] = useState([])
    const [visible, setVisible] = useState(false)
    const [selectedGrade, setSelectedGrade] = useState()
    const [selectedDivision, setSelectedDivision] = useState()
    const [inputpdf, setInputPdf] = useState({ value: '' })
    const [jsonPars, setJasonParse] = useState([])
    const [text, setText] = useState('')
    const [showPdfLinkdataType, setShowPdfLikDateType] = useState()

    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [filterbook, setfilterbook] = useState(initialFormState)
    const [questionList, setQuestionList] = useState([])
    const [errorQuestions, setErrorQuestions] = useState({})
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalData, setModalData] = useState("")
    const [visibleSolution, setVisibleSolution] = useState(false);
    const inputFile = useRef(null);

    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [syllabusNameSort, setSyllabusNameSort] = useState(null);
    const [subjectNameSort, setSubjectNameSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);
    const [subtopicNameSort, setSubtopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["syllabusStructureMasterDetails.syllabusStructureName", "subjectMasterDetails.subjectName", "lessonMasterDetails.lessonName", "topicMasterDetails.topicName", "subTopicMasterDetails.subTopicName"];

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (filterbook.syllabusStructureMasterId !== '' && filterbook.subjectMasterId !== '') {
                let apiUrl = '/get-question-bank-import-log?';
                if (filterbook.syllabusStructureMasterId) {
                    apiUrl += `syllabusStructureMasterId=${filterbook.syllabusStructureMasterId}&`;
                }
                if (filterbook.subjectMasterId) {
                    apiUrl += `subjectMasterId=${filterbook.subjectMasterId}&`
                }
                if (filterbook.lessonMasterId) {
                    apiUrl += `lessonMasterId=${filterbook.lessonMasterId}&`;
                }
                if (filterbook.topicMasterId) {
                    apiUrl += `topicMasterId=${filterbook.topicMasterId}&`;
                }
                if (filterbook.subTopicMasterId) {
                    apiUrl += `subTopicMasterId=${filterbook.subTopicMasterId}&`;
                }
                apiUrl = apiUrl.replace(/&$/, '');
                setSubtopicList(await searchArray("A", apiUrl, searchKeys, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        if (filterbook.syllabusStructureMasterId !== '' && filterbook.subjectMasterId !== '') {
            let apiUrl = '/get-question-bank-import-log?';
            if (filterbook.syllabusStructureMasterId) {
                apiUrl += `syllabusStructureMasterId=${filterbook.syllabusStructureMasterId}&`;
            }
            if (filterbook.subjectMasterId) {
                apiUrl += `subjectMasterId=${filterbook.subjectMasterId}&`
            }
            if (filterbook.lessonMasterId) {
                apiUrl += `lessonMasterId=${filterbook.lessonMasterId}&`;
            }
            if (filterbook.topicMasterId) {
                apiUrl += `topicMasterId=${filterbook.topicMasterId}&`;
            }
            if (filterbook.subTopicMasterId) {
                apiUrl += `subTopicMasterId=${filterbook.subTopicMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.data);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [filterbook, refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(subtopicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(subtopicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > subtopicList.length) {
            endIndex = subtopicList.length;
        }
        setDisplayedData(subtopicList.slice(startIndex, endIndex));
    }, [subtopicList, currPage, itemsPerPage]);

    const getTextBookList = () => {
        if (filterbook.syllabusStructureMasterId !== '' && filterbook.subjectMasterId !== '') {
            let apiUrl = '/get-question-bank-import-log?';
            if (filterbook.syllabusStructureMasterId) {
                apiUrl += `syllabusStructureMasterId=${filterbook.syllabusStructureMasterId}&`;
            }
            if (filterbook.subjectMasterId) {
                apiUrl += `subjectMasterId=${filterbook.subjectMasterId}&`
            }
            if (filterbook.lessonMasterId) {
                apiUrl += `lessonMasterId=${filterbook.lessonMasterId}&`;
            }
            if (filterbook.topicMasterId) {
                apiUrl += `topicMasterId=${filterbook.topicMasterId}&`;
            }
            if (filterbook.subTopicMasterId) {
                apiUrl += `subTopicMasterId=${filterbook.subTopicMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.data)
                    setAddNew(!addNew);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log(errorMsg)
                });
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-all-syllabus-structure`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setfilterbook((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setfilterbook((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subTopicMasterId: '',
                subjectMasterId: '',
            }
        })

        const apiUrl2 = `/syllabus-structure-wise-subjects?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setfilterbook((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subTopicMasterId: '',
            }
        })
        const apiUrl = `/subject-wise-lesson?syllabusStructureMasterId=${filterbook.syllabusStructureMasterId}&subjectMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setfilterbook((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                topicMasterId: '',
                subTopicMasterId: ''
            }
        })
        const apiUrl = `/lesson-wise-topic?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setfilterbook((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subTopicMasterId: ''
            }
        })
        const apiUrl = `/get-sub-topic-master-list?syllabusStructureId=${filterbook.syllabusStructureMasterId}&subjectMasterId=${filterbook.subjectMasterId}&lessonId=${filterbook.lessonMasterId}&topicId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSubTopicViewtopicList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setSubTopicViewtopicList([])
            });
    }

    const handleUploadLogo = async (e) => {
        const file = e.target.files[0];

        if (!file) {
            setfilterbook(prevData => ({
                ...prevData,
                importFile: ''
            }))
            return;
        }

        const fileExtension = file.name.split(".").pop().toLowerCase();
        const body = new FormData();
        body.append("file", file);
        setInputPdf(e.target);

        setfilterbook(prevData => ({
            ...prevData,
            questionData: []
        }));

        if (fileExtension === "xlsx" || fileExtension === "docx") {
            setLoading(true);

            try {
                const link = await getLink(e.target.name, body, setfilterbook);
                if (!link) throw new Error('Link not generated');

                const endpoint = fileExtension === "docx"
                    ? "convert-question-bank-docx"
                    : "convert-question-bank-xlsx-v2";
                const payload = fileExtension === "docx"
                    ? { "wordFilePath": link }
                    : { "excelFilePath": link };

                const response = await authorizedAxiosCommon.post(endpoint, payload);
                setErrorQuestions(validateQuestionData(response.data.convertedData, true, setQuestionList));
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
                Swal.fire({ text: errorMsg });
            } finally {
                setLoading(false);
            }
        } else {
            Swal.fire({ text: "Only xlsx, docx file supported" });
        }
    };

    const validateForm = () => {
        const filterbookDataValid = Object.entries(filterbook).every(([key, value]) => {
            if (key !== 'topicMasterId' && key !== 'subTopicMasterId') {
                if (typeof value === 'string') {
                    if (value === '') {
                        return false;
                    }
                }
            }
            return true;
        });

        const isQuestionDataNotEmpty = filterbook.questionData.length > 0;

        if (filterbook.importFile !== '' && filterbook.importFile.length !== 0) {
            if (!isQuestionDataNotEmpty) {
                return false;
            }
        }

        return filterbookDataValid;
    };

    useEffect(() => {
        if (!Object.values(error).every(error => error === '')) {
            const newErrors = {};

            // Validate each field in filterbook
            for (const [key, value] of Object.entries(filterbook)) {
                if (key !== 'topicMasterId' && key !== 'subTopicMasterId') {
                    if (typeof value === 'string' && value.trim() === '') {
                        newErrors[key] = 'This field is required.';
                    } else {
                        newErrors[key] = ''; // Clear error if field is valid
                    }
                }
            }

            const isQuestionDataNotEmpty = filterbook.questionData.length > 0;

            if (filterbook.importFile !== '' && filterbook.importFile.length !== 0) {
                if (!isQuestionDataNotEmpty) {
                    newErrors['questionData'] = 'At least one question is required.';
                } else {
                    newErrors['questionData'] = ''; // Clear error if questionData is valid
                }
            }

            setError(newErrors); // Update error state with newErrors
        }
    }, [filterbook]);

    const callQuestionBankSaveApi = (apiUrl, filteredBook) => {
        return authorizedAxios && authorizedAxios.post(apiUrl, filteredBook)
            .then(response => {
                resetFormCallQuestionBank();
                Swal.fire({ text: response.data.message });
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            })
    };

    const resetFormCallQuestionBank = () => {
        getTextBookList();
        setfilterbook(prevData => ({
            ...prevData,
            importFile: '',
            questionData: []
        }));
        setQuestionList([]);
        setErrorQuestions({});
        setSyllabusNameSort(null);
        setSubjectNameSort(null);
        setLessonNameSort(null);
        setTopicNameSort(null);
        setSubtopicNameSort(null);
        if (inputFile.current) inputFile.current.value = '';
    };

    // const addTextBook = () => {
    //     if (validateForm()) {
    //         setLoading(true);
    //         let filteredBook = { ...filterbook };
    //         const fileExtension = filterbook.importFile.split('.').pop().toLowerCase();

    //         delete filteredBook.importFile;
    //         const questionIds = validateQuestionData(filterbook.questionData, false);
    //         if (fileExtension === "docx") {
    //             const apiUrl = '/import-question-bank-docx';

    //             if (questionIds.errorCount > 0) {
    //                 const matchedQuestionIndices = questionIds.errorquestionIds.map(id => {
    //                     const index = questionList.findIndex(question => question.no === id);
    //                     return index !== -1 ? (index + 1).toString() : null;
    //                 }).filter(index => index !== null).join(', ');

    //                 const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;

    //                 Swal.fire({
    //                     text: message
    //                 });
    //                 return;
    //             }

    //             callQuestionBankSaveApi(apiUrl, filteredBook);
    //         } else if (fileExtension === "xlsx") {
    //             const apiUrl = `/import-question-bank-xlsx`;

    //             if (questionIds.errorCount > 0) {
    //                 const matchedQuestionIndices = questionIds.errorquestionIds.map(id => {
    //                     const index = questionList.findIndex(question => question.no === id);
    //                     return index !== -1 ? (index + 1).toString() : null;
    //                 }).filter(index => index !== null).join(', ');

    //                 const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;

    //                 Swal.fire({
    //                     text: message
    //                 });
    //                 return;
    //             }

    //             callQuestionBankSaveApi(apiUrl, filteredBook);
    //         }
    //     } else {
    //         const newErrors = {};

    //         for (const [key, value] of Object.entries(filterbook)) {
    //             if (key !== 'topicMasterId' && key !== 'subTopicMasterId') {
    //                 if (typeof value === 'string' && value.trim() === '') {
    //                     newErrors[key] = 'This field is required.';
    //                 } else {
    //                     newErrors[key] = '';
    //                 }
    //             }
    //         }
    //         const isQuestionDataNotEmpty = filterbook.questionData.length > 0;

    //         if (filterbook.importFile !== '' && !isQuestionDataNotEmpty) {
    //             newErrors['questionData'] = 'At least one question is required.';
    //         } else {
    //             newErrors['questionData'] = '';
    //         }

    //         setError(newErrors);
    //     }

    //     setLoading(false);
    // }

    const addTextBook = () => {
        if (!validateForm()) {
            handleFormErrors();
            setLoading(false);
            return;
        }

        setLoading(true);
        const filteredBook = { ...filterbook };
        const fileExtension = filterbook.importFile.split('.').pop().toLowerCase();

        delete filteredBook.importFile;

        const questionIds = validateQuestionData(filterbook.questionData, false);

        if (questionIds.errorCount > 0) {
            handleQuestionErrors(questionIds.errorquestionIds);
            setLoading(false);
            return;
        }

        const apiUrl = fileExtension === "docx" ? '/import-question-bank-docx' : '/import-question-bank-xlsx';

        callQuestionBankSaveApi(apiUrl, filteredBook)
            .finally(() => {
                setLoading(false); // End loading
            });
    };

    const handleFormErrors = () => {
        const newErrors = {};

        for (const [key, value] of Object.entries(filterbook)) {
            if (key !== 'topicMasterId' && key !== 'subTopicMasterId') {
                newErrors[key] = typeof value === 'string' && value.trim() === '' ? 'This field is required.' : '';
            }
        }

        if (filterbook.importFile !== '' && filterbook.questionData.length === 0) {
            newErrors['questionData'] = 'At least one question is required.';
        } else if (filterbook.questionData.length > 0) {
            newErrors['questionData'] = '';
        }

        setError(newErrors);
    };

    const handleQuestionErrors = (errorQuestionIds) => {
        const matchedQuestionIndices = errorQuestionIds
            .map(id => {
                const index = questionList.findIndex(question => question.no === id);
                return index !== -1 ? (index + 1).toString() : null;
            })
            .filter(index => index !== null)
            .join(', ');

        const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;

        Swal.fire({ text: message });
    };

    useEffect(() => {
        if (showPdfLink !== null) {
            if (showPdfLink.indexOf('[') >= 0) {
                setShowPdfLikDateType("array")
                setJasonParse(JSON.parse(showPdfLink))
            }
            else {
                setShowPdfLikDateType("string")
                setText(showPdfLink)
            }
        }
        else {
            setShowPdfLikDateType("string")
            setText(showPdfLink)
        }
    }, [showPdfLink])

    const getFileName = (path) => {
        let i = path.length - 1;
        let name = "";
        while (i >= 0 && path[i] !== "/") {
            name = path[i] + name;
            i--;
        }
        return name;
    }

    const handleInputReset = () => {
        setfilterbook(initialFormState);
        inputpdf.value = '';
        inputFile.current.value = '';
        setSubtopicList([]);
        setQuestionList([]);
        setErrorQuestions({});
        setModalImageSrc('');
        setVisibleImage(false);
        setModalData("");
        setVisibleSolution(false);
        setDisplayedData([]);
        setError(initialErrorState);
    }

    useEffect(() => {
        if (syllabusNameSort == true || syllabusNameSort == false) {
            setSubjectNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubtopicNameSort(null);
        }
    }, [syllabusNameSort])

    useEffect(() => {
        if (subjectNameSort == true || subjectNameSort == false) {
            setSyllabusNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
            setSubtopicNameSort(null);
        }
    }, [subjectNameSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusNameSort(null);
            setSubjectNameSort(null);
            setTopicNameSort(null);
            setSubtopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setSyllabusNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
            setSubtopicNameSort(null);
        }
    }, [topicNameSort])

    useEffect(() => {
        if (subtopicNameSort == true || subtopicNameSort == false) {
            setSyllabusNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [subtopicNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                {/* <Header /> */}
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Upload</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i> Upload Text Book</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabusStructureMasterId' onChange={handleSyllabusChange} value={filterbook.syllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.syllabusStructureMasterId && <p style={{ color: 'red' }}>{error.syllabusStructureMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChange} value={filterbook.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='lessonMasterId' onChange={handleLessonChange} value={filterbook.lessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.lessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.lessonMasterId && <p style={{ color: 'red' }}>{error.lessonMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='topicMasterId' onChange={handleTopicChange} value={filterbook.topicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.topicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.topicMasterId && <p style={{ color: 'red' }}>{error.topicMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subTopicMasterId' onChange={handleInputChange} value={filterbook.subTopicMasterId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subTopicViewtopicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.subTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.subTopicMasterId && <p style={{ color: 'red' }}>{error.subTopicMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Text Book Question Bank : <span style={{ color: "red" }}>only xlsx & docx file supported </span></label>
                                                    <input required type="file" className="form-control" name="importFile" onChange={handleUploadLogo} ref={inputFile} />
                                                    <a download href='https://api.examninja.co.in/files/question-bank-import-ex.xlsx'>Sample xlsx file</a>&nbsp;
                                                    <a download href='https://api.examninja.co.in/files/SampleDoc.docx'>Sample docx file</a>
                                                    {error.importFile && <p style={{ color: 'red' }}>{error.importFile}</p>}
                                                </div>
                                            </div>

                                            <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>
                                                <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addTextBook}>Save</button>
                                            </div>

                                            {/* {questionList.length === 0 && <div className="d-grid gap-2 mt-2">
                                                <div class="tab-content rounded-bottom custom_table">
                                                    <div className='search_btn_row'>
                                                        <input
                                                            className="form-control mr-sm-2"
                                                            type="Search"
                                                            placeholder="Search"
                                                            value={searchValue}
                                                            onChange={handleEmptySearch}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter') {
                                                                    handleSearch();
                                                                }
                                                            }}
                                                        />
                                                        <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                    </div>
                                                    <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">Uploaded Files</th>
                                                                    <th scope="col">Total Question Count</th>
                                                                    <th scope="col">Imported Question Count</th>
                                                                    <th scope="col">
                                                                        Syllabus Structure
                                                                        <SortIcon sortState={syllabusNameSort} setSortState={setSyllabusNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"syllabusStructureMasterDetails.syllabusStructureName"} />
                                                                    </th>
                                                                    <th scope="col">
                                                                        Subject
                                                                        <SortIcon sortState={subjectNameSort} setSortState={setSubjectNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"subjectMasterDetails.subjectName"} />
                                                                    </th>
                                                                    <th scope="col">
                                                                        Lesson
                                                                        <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"lessonMasterDetails.lessonName"} />
                                                                    </th>
                                                                    <th scope="col">
                                                                        Topic
                                                                        <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"topicMasterDetails.topicName"} />
                                                                    </th>
                                                                    <th scope="col">
                                                                        Sub Topic
                                                                        <SortIcon sortState={subtopicNameSort} setSortState={setSubtopicNameSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"subTopicMasterDetails.subTopicName"} />
                                                                    </th>
                                                                    <th scope="col">Note</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    displayedData?.length > 0 ?
                                                                        displayedData.map((lesson) => {
                                                                            return (
                                                                                <tr className={lesson.importStatus == "IMPORTED" ? 'greenTable' : lesson.importStatus == "FAILED" ? "redTable" : lesson.importStatus == "NOT STARTED" ? "yellowTable" : "yellowTable"}>
                                                                                    <td>{getFileName(lesson?.localFilePath)}<a href={lesson.localFilePath} download style={{ textDecoration: "none" }}><i class="fa-solid fa-download"></i></a></td>
                                                                                    <td>{lesson.importedQuestionCount}</td>
                                                                                    <td>{lesson.importedQuestionCount}</td>
                                                                                    <td>{lesson?.syllabusStructureMasterDetails?.syllabusStructureName}</td>
                                                                                    <td>{lesson?.subjectMasterDetails?.subjectName}</td>
                                                                                    <td>{lesson?.lessonMasterDetails?.lessonName}</td>
                                                                                    <td>{lesson?.topicMasterDetails?.topicName}</td>
                                                                                    <td>{lesson?.subTopicMasterDetails?.subTopicName}</td>
                                                                                    <td>
                                                                                        <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                            setShowPdfLink(lesson.note)
                                                                                            setVisible(true)
                                                                                            setSelectedGrade(lesson?.syllabusStructureMasterDetails?.syllabusStructureName)
                                                                                            setSelectedDivision(lesson?.subjectMasterDetails?.subjectName)
                                                                                        }}><i class="fa fa-eye" ></i> Error</button>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                        :
                                                                        (<tr>
                                                                            <th colspan={"100%"} style={{ textAlign: 'center' }}>No Student Available</th>

                                                                        </tr>)
                                                                }

                                                            </tbody>
                                                        </table>

                                                        <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={subtopicList.length} />

                                                    </div>
                                                </div>
                                            </div>} */}

                                            {questionList.length !== 0 && <div className="d-grid gap-2 mt-2">
                                                <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                    <div>
                                                        {errorQuestions.errorCount > 0 && (
                                                            <div className="alert alert-danger" role="alert">
                                                                {errorQuestions.errorCount === 1 ?
                                                                    `There is ${errorQuestions.errorCount} invalid or empty question` :
                                                                    `There are ${errorQuestions.errorCount} invalid or empty questions`
                                                                }
                                                            </div>
                                                        )}
                                                    </div>
                                                    {error.questionData && <p style={{ color: 'red' }}>{error.questionData}</p>}
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                {questionList?.length > 0 && <th>
                                                                    <input
                                                                        type='checkbox'
                                                                        checked={filterbook.questionData.length === questionList.length}
                                                                        onClick={() => handleSelectAll(questionList, filterbook, setfilterbook)}
                                                                    /> All
                                                                </th>}
                                                                <th scope="col" className='sl_no'>Sr. No.</th>
                                                                <th scope='col'>Q_Level</th>
                                                                <th scope='col'>Q_Type</th>
                                                                <th scope='col'>Question</th>
                                                                <th scope="col">Option_a</th>
                                                                <th scope="col">Option_b </th>
                                                                <th scope="col">Option_c</th>
                                                                <th scope="col">Option_d</th>
                                                                <th scope='col'>Answer</th>
                                                                <th scope='col'>Solution</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                questionList?.length > 0 ?
                                                                    questionList?.map((question, index) => {
                                                                        const rowClass = isErrorQuestion(errorQuestions, question) ? 'error-row' : '';

                                                                        return (
                                                                            <tr key={index} className={rowClass}>
                                                                                <td><input type='checkbox' checked={filterbook.questionData.some(q => q.no === question.no)} onChange={() => handleQuestionUpdate(question, filterbook, setfilterbook)} /></td>
                                                                                <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                {question.q_level ? <td>{question.q_level}</td> : <td>E</td>}
                                                                                {question.q_type ? <td>{question.q_type}</td> : <td>S</td>}
                                                                                {/* <td><ViewImageAndText inputString={question.question} onViewImage={onViewImage} /></td>
                                                                                <td><ViewImageAndText inputString={question.options['a)']} onViewImage={onViewImage} /></td>
                                                                                <td><ViewImageAndText inputString={question.options['b)']} onViewImage={onViewImage} /></td>
                                                                                <td><ViewImageAndText inputString={question.options['c)']} onViewImage={onViewImage} /></td>
                                                                                <td><ViewImageAndText inputString={question.options['d)']} onViewImage={onViewImage} /></td> */}
                                                                                <td><div dangerouslySetInnerHTML={{ __html: question.question }} /></td>
                                                                                <td><div dangerouslySetInnerHTML={{ __html: question.options['a)'] }} /></td>
                                                                                <td><div dangerouslySetInnerHTML={{ __html: question.options['b)'] }} /></td>
                                                                                <td><div dangerouslySetInnerHTML={{ __html: question.options['c)'] }} /></td>
                                                                                <td><div dangerouslySetInnerHTML={{ __html: question.options['d)'] }} /></td>
                                                                                <td>{question.answer}</td>
                                                                                <td>
                                                                                    <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                                                        setVisibleSolution(!visibleSolution)
                                                                                        setModalData(question.solution)
                                                                                    }}><i class="fa fa-eye" ></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    (<tr>
                                                                        <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                    </tr>)
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CModal
                    visible={visible}
                    onClose={() => setVisible(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <div className="book book-modal">
                        <div className='table-header-like'>  {selectedGrade} - {selectedDivision}</div>
                        <div style={{ overflowY: "scroll", }} className='page' >
                            <div>
                                {
                                    showPdfLinkdataType == "array" ?
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                                    <th scope="col">Name </th>
                                                    <th scope="col">Purpose </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    jsonPars.map((lesson, index) => {
                                                        return (
                                                            <tr>
                                                                <th scope="row" className='sl_no'>{index + 1}</th>
                                                                <td>{lesson.record[2]}</td>
                                                                <td>{lesson.purpose}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        :
                                        <div className='no-error-class'>{text ? text : "No error found"}</div>
                                }
                            </div>
                        </div>
                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                            Close
                        </button>
                    </div>
                </CModal>

                {visibleSolution && <SolutionModal visibleSolution={visibleSolution} setVisibleSolution={setVisibleSolution} modalData={modalData} />}

                {visibleImage && <ImageModal visibleImage={visibleImage} setVisibleImage={setVisibleImage} modalImageSrc={modalImageSrc} />}

            </div>
            <Footer />
        </>
    )
};

export default UploadContentTextBook;


